import { getRouteApi, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";
import { toast } from "sonner";
import { Logo } from "@/components/Logo";
import { TurnstileProvider } from "@/hooks/use-turnstile";
import { AuthLayout } from "../../components/catalyst/AuthLayout";
import { Heading } from "../../components/catalyst/Heading";
import { Form } from "./Form";
import { Partner } from "./Partner";
import { Socials } from "./Socials";

const route = getRouteApi("/auth/signin");

export function SignIn() {
	const navigate = useNavigate();
	const { success } = route.useSearch();

	useEffect(() => {
		let timeout: NodeJS.Timeout;
		if (success === "email-verified") {
			timeout = setTimeout(() => {
				toast.success("Your email has been verified!", {
					id: "email-verified",
				});
				navigate({ to: "/auth/signin" });
			}, 100);
		}
		return () => clearTimeout(timeout);
	}, [success, navigate]);

	return (
		<AuthLayout>
			<TurnstileProvider>
				<div className="flex flex-col gap-6 w-full max-w-md">
					<div className="flex flex-col items-center gap-4">
						<Logo />
						<Heading>Sign in to your account</Heading>
					</div>
					<Form />
					<Socials />
					<Partner />
				</div>
			</TurnstileProvider>
		</AuthLayout>
	);
}
